export default __webpack_public_path__ + "static/linkedIn_icon-5a8ac64aeead7bc9ccbefffe87735e39.png";